// extracted by mini-css-extract-plugin
module.exports = {"level_0":"NoFeedbackScreen_level_0__245T4"};